import i18next from "i18next";
import React, { Component } from "react";
import { connect } from "react-redux";
import { translate } from "../../base/i18n/functions";
import { closeLoginModal, setAuthError, setAuthLoading, setAuthStep, setAuthenticated, setOtp, setPhoneNumber, setUserInfo, setUsername, } from "../actions";
import { authApi } from "../api";
import { ensureDeviceId } from "../functions";
function toPersianDigits(str) {
    const persianDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    return str.replace(/[0-9]/g, (d) => persianDigits[parseInt(d, 10)]);
}
function toEnglishDigits(str) {
    return str.replace(/[۰-۹]/g, (d) => String("۰۱۲۳۴۵۶۷۸۹".indexOf(d)));
}
const IRAN_MOBILE_REGEX = /^09\d{9}$/;
const RESEND_SECONDS = 120;
class LoginModal extends Component {
    // FIX: AbortController به‌عنوان instance variable تعریف میشه (نه state)
    // چون setState آسنکرونه و باعث race condition در abort/restart میشد
    _webOtpAbortController = null;
    constructor(props) {
        super(props);
        this.state = {
            otpValue: "",
            phoneError: null,
            resendCountdown: RESEND_SECONDS,
            resendLoading: false,
            resendTimerId: null,
            fakeLoading: false,
        };
        this._onClose = this._onClose.bind(this);
        this._onPhoneChange = this._onPhoneChange.bind(this);
        this._onRequestOtp = this._onRequestOtp.bind(this);
        this._onOtpChange = this._onOtpChange.bind(this);
        this._onVerifyOtp = this._onVerifyOtp.bind(this);
        this._onUsernameChange = this._onUsernameChange.bind(this);
        this._onSetUsername = this._onSetUsername.bind(this);
        this._onBackToPhone = this._onBackToPhone.bind(this);
        this._onResendOtp = this._onResendOtp.bind(this);
    }
    componentDidMount() {
        if (this.props.isOpen) {
            this._checkExistingAuth();
        }
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isOpen && this.props.isOpen) {
            this._checkExistingAuth();
        }
        if (prevProps.step !== "otp" && this.props.step === "otp") {
            this._startWebOtpListener();
        }
        if (prevProps.step === "otp" && this.props.step !== "otp") {
            this._abortWebOtp();
        }
    }
    componentWillUnmount() {
        this._abortWebOtp();
        this._clearResendTimer();
    }
    _startWebOtpListener() {
        if (!("OTPCredential" in window)) {
            return;
        }
        // FIX: abort کاملاً sync است — بدون setState، بدون race condition
        if (this._webOtpAbortController) {
            this._webOtpAbortController.abort();
        }
        const abort = new AbortController();
        this._webOtpAbortController = abort;
        navigator.credentials
            .get({
            otp: { transport: ["sms"] },
            signal: abort.signal,
        })
            .then((credential) => {
            if (credential?.code) {
                const code = String(credential.code).replace(/\D/g, "").slice(0, 6);
                if (code.length === 6) {
                    this.setState({ otpValue: code }, () => {
                        this.props.dispatch(setOtp(code));
                        this._triggerVerifyWithFakeLoading(code);
                    });
                }
            }
        })
            .catch(() => {
            // AbortError هنگام تغییر مرحله طبیعی است
        });
    }
    _abortWebOtp() {
        // FIX: abort کاملاً sync است
        if (this._webOtpAbortController) {
            this._webOtpAbortController.abort();
            this._webOtpAbortController = null;
        }
    }
    _clearResendTimer() {
        if (this.state.resendTimerId) {
            clearInterval(this.state.resendTimerId);
        }
    }
    _startResendTimer() {
        this._clearResendTimer();
        let countdown = RESEND_SECONDS;
        this.setState({ resendCountdown: countdown, resendTimerId: null });
        const timerId = setInterval(() => {
            countdown -= 1;
            if (countdown <= 0) {
                clearInterval(timerId);
                this.setState({ resendCountdown: 0, resendTimerId: null });
            }
            else {
                this.setState({ resendCountdown: countdown });
            }
        }, 1000);
        this.setState({ resendTimerId: timerId });
    }
    async _checkExistingAuth() {
        const { dispatch } = this.props;
        if (authApi.isAuthenticated()) {
            try {
                const userInfo = await authApi.getMe();
                dispatch(setUserInfo(userInfo));
                dispatch(setAuthenticated(true));
                authApi.saveUserInfo(userInfo);
                if (userInfo.username === null) {
                    dispatch(setAuthStep("username"));
                }
                else {
                    dispatch(closeLoginModal());
                }
            }
            catch {
                dispatch(setAuthStep("phone"));
            }
        }
    }
    _onClose() {
        this._abortWebOtp();
        this._clearResendTimer();
        this.props.dispatch(closeLoginModal());
        this.setState({
            otpValue: "",
            phoneError: null,
            resendCountdown: RESEND_SECONDS,
            resendTimerId: null,
            fakeLoading: false,
        });
    }
    _onPhoneChange(e) {
        const rawValue = e.target.value;
        const englishValue = toEnglishDigits(rawValue).replace(/\D/g, "").slice(0, 11);
        this.props.dispatch(setPhoneNumber(englishValue));
        if (englishValue.length > 0) {
            if (!englishValue.startsWith("0")) {
                this.setState({ phoneError: "auth.errors.phoneMustStartWithZero" });
            }
            else if (englishValue.length > 1 && !englishValue.startsWith("09")) {
                this.setState({ phoneError: "auth.errors.phoneMustStartWith09" });
            }
            else if (englishValue.length === 11 && !IRAN_MOBILE_REGEX.test(englishValue)) {
                this.setState({ phoneError: "auth.errors.invalidPhoneNumber" });
            }
            else {
                this.setState({ phoneError: null });
            }
        }
        else {
            this.setState({ phoneError: null });
        }
    }
    _formatPhoneDisplay(phone) {
        const currentLang = i18next.language || "fa";
        const usePersianDigits = currentLang === "fa";
        const formatted = usePersianDigits ? toPersianDigits(phone) : phone;
        if (formatted.length > 4) {
            return formatted.slice(0, 4) + "-" + formatted.slice(4);
        }
        return formatted;
    }
    async _onRequestOtp() {
        const { dispatch, phoneNumber } = this.props;
        dispatch(setAuthLoading(true));
        dispatch(setAuthError(null));
        try {
            await authApi.requestOtp(phoneNumber);
            this.setState({ otpValue: "" });
            dispatch(setOtp(""));
            dispatch(setAuthStep("otp"));
            this._startResendTimer();
        }
        catch {
            dispatch(setAuthError("auth.errors.requestOtpFailed"));
        }
        finally {
            dispatch(setAuthLoading(false));
        }
    }
    async _onResendOtp() {
        const { dispatch, phoneNumber } = this.props;
        dispatch(setAuthLoading(false));
        dispatch(setAuthError(null));
        this.setState({ resendLoading: true });
        try {
            await authApi.requestOtp(phoneNumber);
            this._startResendTimer();
        }
        catch {
            dispatch(setAuthError("auth.errors.requestOtpFailed"));
        }
        finally {
            this.setState({ resendLoading: false });
        }
    }
    _triggerVerifyWithFakeLoading(otpCode) {
        if (this.state.fakeLoading || this.props.loading) {
            return;
        }
        this.setState({ fakeLoading: true });
        setTimeout(() => {
            this.setState({ fakeLoading: false }, () => {
                this._onVerifyOtp(otpCode);
            });
        }, 1000);
    }
    _onOtpChange(e) {
        const englishValue = toEnglishDigits(e.target.value);
        const value = englishValue.replace(/\D/g, "").slice(0, 6);
        this.setState({ otpValue: value });
        this.props.dispatch(setOtp(value));
        if (value.length === 6 && !this.props.loading && !this.state.fakeLoading) {
            this._triggerVerifyWithFakeLoading(value);
        }
    }
    async _onVerifyOtp(otpCode) {
        const { dispatch, phoneNumber, pendingRoom } = this.props;
        const otp = otpCode ?? this.state.otpValue;
        if (otp.length !== 6) {
            return;
        }
        dispatch(setAuthLoading(true));
        dispatch(setAuthError(null));
        try {
            const response = await authApi.verifyOtp(phoneNumber, otp);
            authApi.saveTokens(response.accessToken, response.refreshToken);
            dispatch(setAuthenticated(true));
            ensureDeviceId();
            const userInfo = await authApi.getMe();
            dispatch(setUserInfo(userInfo));
            authApi.saveUserInfo(userInfo);
            if (userInfo.username === null) {
                dispatch(setAuthStep("username"));
            }
            else {
                if (pendingRoom) {
                    localStorage.setItem("pendingRoom", pendingRoom);
                }
                dispatch(closeLoginModal());
                this.props.onLoginSuccess?.();
            }
        }
        catch {
            dispatch(setAuthError("auth.errors.verifyOtpFailed"));
            this.setState({ otpValue: "" });
            dispatch(setOtp(""));
        }
        finally {
            dispatch(setAuthLoading(false));
        }
    }
    _onUsernameChange(e) {
        this.props.dispatch(setUsername(e.target.value));
    }
    async _onSetUsername() {
        const { dispatch, username, pendingRoom } = this.props;
        dispatch(setAuthLoading(true));
        dispatch(setAuthError(null));
        try {
            await authApi.setUsername(username);
            const userInfo = await authApi.getMe();
            dispatch(setUserInfo(userInfo));
            authApi.saveUserInfo(userInfo);
            if (pendingRoom) {
                localStorage.setItem("pendingRoom", pendingRoom);
            }
            dispatch(closeLoginModal());
            this.props.onLoginSuccess?.();
        }
        catch {
            dispatch(setAuthError("auth.errors.setUsernameFailed"));
        }
        finally {
            dispatch(setAuthLoading(false));
        }
    }
    _onPhoneSubmit(e) {
        e.preventDefault();
        if (!this.props.loading && this.props.phoneNumber) {
            this._onRequestOtp();
        }
    }
    _scrollInputIntoView(e) {
        setTimeout(() => {
            e.target?.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 300);
    }
    _onBackToPhone() {
        this._clearResendTimer();
        this.props.dispatch(setAuthStep("phone"));
        this.setState({ otpValue: "", resendCountdown: RESEND_SECONDS, resendTimerId: null, fakeLoading: false });
    }
    _renderPhoneStep() {
        const { t, phoneNumber, loading, error } = this.props;
        const { phoneError } = this.state;
        const displayValue = this._formatPhoneDisplay(phoneNumber);
        const isValidPhone = IRAN_MOBILE_REGEX.test(phoneNumber);
        return (React.createElement("form", { className: "login-step login-step-phone", onSubmit: (e) => this._onPhoneSubmit(e) },
            React.createElement("p", { className: "login-step-phone_title" }, t("dialog.phoneNumber")),
            React.createElement("input", { autoComplete: "tel-national", autoFocus: true, className: `login-input ${phoneError ? "login-input--error" : ""}`, dir: "ltr", disabled: loading, inputMode: "tel", name: "tel", onChange: this._onPhoneChange, onFocus: (e) => this._scrollInputIntoView(e), placeholder: t("auth.phonePlaceholder"), type: "tel", value: displayValue }),
            phoneError && React.createElement("div", { className: "login-error" }, t(phoneError)),
            error && React.createElement("div", { className: "login-error" }, t(error)),
            React.createElement("button", { className: `login-button ${loading ? "login-button--loading" : ""}`, disabled: loading || !isValidPhone, type: "submit" }, loading ? React.createElement("span", { className: "login-spinner" }) : t("auth.sendCode"))));
    }
    _onOtpSubmit(e) {
        e.preventDefault();
        const { otpValue, fakeLoading } = this.state;
        if (!this.props.loading && !fakeLoading && otpValue.length === 6) {
            this._triggerVerifyWithFakeLoading(otpValue);
        }
    }
    _renderResendSection() {
        const { t } = this.props;
        const { resendCountdown, resendLoading } = this.state;
        if (resendCountdown > 0) {
            const minutes = Math.floor(resendCountdown / 60);
            const seconds = resendCountdown % 60;
            const display = toPersianDigits(String(minutes).padStart(2, "0")) +
                ":" +
                toPersianDigits(String(seconds).padStart(2, "0"));
            return (React.createElement("p", { className: "resend-otp-timer" },
                t("auth.resendIn"),
                " ",
                React.createElement("span", { className: "resend-otp-countdown" }, display)));
        }
        return (React.createElement("button", { className: "resend-otp-button", disabled: resendLoading, onClick: this._onResendOtp, type: "button" }, resendLoading ? React.createElement("span", { className: "login-spinner-code" }) : t("auth.resendCode")));
    }
    _renderOtpStep() {
        const { t, loading, error, phoneNumber } = this.props;
        const { otpValue, fakeLoading } = this.state;
        const formattedPhone = this._formatPhoneDisplay(phoneNumber);
        const isSubmitLoading = loading || fakeLoading;
        const currentLang = i18next.language || "fa";
        const usePersianDigits = currentLang === "fa";
        const codeSentMessage = t("auth.codeSentTo", { phone: "PHONE_PLACEHOLDER" });
        const messageParts = codeSentMessage.split("PHONE_PLACEHOLDER");
        return (React.createElement("form", { className: "login-step login-step-otp", onSubmit: (e) => this._onOtpSubmit(e) },
            React.createElement("p", { className: "login-step-phone_title" }, t("auth.verificationCode")),
            React.createElement("p", { className: "login-step-phone-display" },
                messageParts[0],
                React.createElement("span", { className: "phone-number-ltr" }, formattedPhone),
                messageParts[1]),
            React.createElement("div", { className: "otp-single-input-wrapper" },
                React.createElement("input", { autoComplete: "one-time-code", autoFocus: true, className: "otp-single-input", dir: "ltr", readOnly: isSubmitLoading, inputMode: "numeric", maxLength: 6, name: "otp", onChange: this._onOtpChange, pattern: "[0-9]*", placeholder: "------", type: "text", value: otpValue }),
                React.createElement("div", { className: "otp-display" }, [0, 1, 2, 3, 4, 5].map((i) => (React.createElement(React.Fragment, { key: i },
                    React.createElement("span", { className: `otp-char ${otpValue[i] ? "filled" : "empty"}` }, otpValue[i] ? (usePersianDigits ? toPersianDigits(otpValue[i]) : otpValue[i]) : ""),
                    i < 5 && React.createElement("span", { className: "otp-separator" }, "-")))))),
            error && React.createElement("div", { className: "login-error" }, t(error)),
            React.createElement("div", { className: "login-button-group" },
                React.createElement("button", { className: `login-button ${isSubmitLoading ? "login-button--loading" : ""}`, disabled: isSubmitLoading || otpValue.length < 6, type: "submit" }, isSubmitLoading ? React.createElement("span", { className: "login-spinner" }) : t("auth.verify")),
                React.createElement("button", { className: "login-back-button-inline", disabled: isSubmitLoading, onClick: () => this._onBackToPhone(), type: "button" }, t("auth.back"))),
            React.createElement("div", { className: "resend-otp-wrapper" }, this._renderResendSection())));
    }
    _onUsernameSubmit(e) {
        e.preventDefault();
        if (!this.props.loading && this.props.username) {
            this._onSetUsername();
        }
    }
    _isUsernameValid(value) {
        return value.length > 0 && !/^[0-9]/.test(value);
    }
    _getUsernameError(value) {
        if (value.length > 0 && /^[0-9]/.test(value)) {
            return "auth.errors.usernameCannotStartWithNumber";
        }
        return null;
    }
    _renderUsernameStep() {
        const { t, username, loading, error } = this.props;
        const usernameError = this._getUsernameError(username);
        return (React.createElement("form", { className: "login-step login-step-username", onSubmit: (e) => this._onUsernameSubmit(e) },
            React.createElement("p", { className: "login-step-phone_title" }, t("auth.username")),
            React.createElement("input", { autoComplete: "username", autoFocus: true, className: `login-input ${usernameError ? "login-input--error" : ""}`, disabled: loading, name: "username", onChange: this._onUsernameChange, placeholder: t("auth.usernamePlaceholder"), type: "text", value: username }),
            usernameError && React.createElement("div", { className: "login-error" }, t(usernameError)),
            error && React.createElement("div", { className: "login-error" }, t(error)),
            React.createElement("button", { className: `login-button ${loading ? "login-button--loading" : ""}`, disabled: loading || !this._isUsernameValid(username), type: "submit" }, loading ? React.createElement("span", { className: "login-spinner" }) : t("auth.save"))));
    }
    render() {
        const { isOpen, t, step } = this.props;
        if (!isOpen) {
            return null;
        }
        return (React.createElement("div", { className: "login-modal-overlay", onClick: this._onClose },
            React.createElement("div", { className: "login-modal-content", onClick: (e) => e.stopPropagation() },
                React.createElement("div", { className: "login-modal-right" },
                    React.createElement("div", { className: "login-modal-title" },
                        React.createElement("h2", { className: "login-title" }, t("auth.loginSignup")),
                        React.createElement("p", { className: "login-welcome" }, t("auth.welcome"))),
                    step === "phone" && this._renderPhoneStep(),
                    step === "otp" && this._renderOtpStep(),
                    step === "username" && this._renderUsernameStep()),
                React.createElement("div", { className: "login-modal-left" },
                    React.createElement("div", { className: "login-logo" },
                        React.createElement("img", { alt: "didar", className: "logobox", src: "images/didar-logo.png" })),
                    React.createElement("p", { className: "login-tagline" }, t("auth.tagline"))))));
    }
}
function _mapStateToProps(state) {
    const authState = state["features/auth"];
    return {
        error: authState?.error ?? null,
        isOpen: authState?.isLoginModalOpen ?? false,
        loading: authState?.loading ?? false,
        otp: authState?.otp ?? "",
        pendingRoom: authState?.pendingRoom ?? null,
        phoneNumber: authState?.phoneNumber ?? "",
        step: authState?.step ?? "phone",
        username: authState?.username ?? "",
    };
}
export default translate(connect(_mapStateToProps)(LoginModal));
